import React from 'react';
import { XCircle } from 'lucide-react';
const painPoints = ['Son las 20:30h, llegas agotada del trabajo y no tienes ni idea de qué cenar que sea saludable y rápido', 'Has probado dietas mil veces pero siempre vuelves al punto de partida porque son imposibles de mantener en el día a día español', 'Tu Airfryer lleva meses cogiendo polvo porque nadie te explicó cómo usarla de verdad para adelgazar', 'Ves recetas "saludables" en Instagram que requieren 20 ingredientes y 45 minutos que no tienes', 'El antojo de las 5PM te destruye cualquier día bueno que hayas tenido', 'La báscula no baja aunque estés haciendo "todo bien" y ya no sabes qué más hacer', 'Comes sano entre semana pero el fin de semana lo arruinas todo y empiezas de cero el lunes'];
export function PainSection() {
  return <section className="bg-cream py-20 px-4" data-id="element-143">
      <div className="max-w-3xl mx-auto" data-id="element-144">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-center text-navy mb-12" data-id="element-145">
          "¿Te Suena Alguna De Estas Situaciones?"
        </h2>

        <div className="space-y-4 mb-12" data-id="element-146">
          {painPoints.map((pain, index) => <div key={index} className="bg-white p-5 rounded-2xl shadow-sm border-l-4 border-gold flex items-start gap-4" data-id="element-147">
              <XCircle className="w-6 h-6 text-gold flex-shrink-0 mt-0.5" data-id="element-148" />
              <p className="text-gray-800 font-medium leading-relaxed" data-id="element-149">
                {pain}
              </p>
            </div>)}
        </div>

        <div className="bg-white p-8 rounded-3xl shadow-lg border-l-4 border-teal relative" data-id="element-150">
          <div className="absolute -top-4 -left-4 text-6xl text-gold/20 font-heading" data-id="element-151">
            "
          </div>
          <p className="text-xl text-navy italic font-medium relative z-10 leading-relaxed" data-id="element-152">
            "Si has dicho sí a aunque sea una de estas situaciones, no es culpa
            tuya. El problema no eres tú. El problema es que nadie te ha dado un
            sistema que funcione dentro de la vida real española."
          </p>
        </div>
      </div>
    </section>;
}